import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import styles from './style.module.scss'
import Layout from '@shared/components/layout'
import useWindowSize from '@shared/hooks/windowSize'
import { staticPages } from '@shared/constants/staticPages'
import { WIDGET } from '@shared/constants'
import { scoreCardSliderLoader } from '@shared/libs/allLoader'

const BreadcrumbNav = dynamic(() => import('@shared/components/breadcrumbNav'))
const Ads = dynamic(() => import('@shared/components/ads'))
const OnMouseAndScroll = dynamic(() => import('@shared/components/lazyLoad/onMouseAndScroll'))
const AllWidget = dynamic(() => import('@shared/components/allWidget'))
// const SeriesPointTable = dynamic(() => import('@shared/components/widgets/seriesPointTable'))
const CommonContent = dynamic(() => import('@shared/components/commonContent'))
const ArrayHTML = dynamic(() => import('@shared/components/InnerHTML/arrayHTML'))
const SeriesMatches = dynamic(() => import('@shared/components/widgets/seriesMatches'))
const SeriesPointTable = dynamic(() => import('@shared/components/widgets/seriesPointTable'))
const ScorecardSlider = dynamic(() => import('@shared-components/scorecardSlider'), { loading: () => scoreCardSliderLoader() })

const CMSContent = ({ data, seoData }) => {
  const router = useRouter()
  const isMobileWebView = router?.query?.isMobileWebView
  const cmsData = data?.data
  const catSubPagesUrl = getPagesURL(data?.catSubPages)
  const [width] = useWindowSize()
  // const isStaticPage = staticPages.includes(router.asPath)
  const isStaticPage = staticPages.some((path) => router.asPath.startsWith(path))
  function getPagesURL(data) {
    const obj = {}
    data?.forEach((e) => {
      obj[e?.eSubType || 'h'] = e
    })
    return obj
  }

  function getAdCode() {
    if (isStaticPage && !isMobileWebView) {
      return {
        0: {
          id: 'div-ad-gpt-fixed-ads-1',
          adIdDesktop: 'Crictracker_New_Desktop_AP_MID_728x90',
          adIdMobile: 'Crictracker_New_Mobile_AP_MID1_300x250',
          dimensionDesktop: [728, 90],
          slotId: '23148549803',
          dimensionMobile: [300, 250],
          mobile: true,
          hideOn: 'none',
          className: 'text-center mb-3 mb-md-4'
        },
        1: {
          id: 'div-ad-gpt-fixed-ads-6',
          adIdDesktop: 'Crictracker_New_Desktop_AP_BTF_728x90',
          adIdMobile: 'Crictracker_New_Mobile_AP_MID2_300x250',
          slotId: '23148549803',
          dimensionDesktop: [728, 90],
          dimensionMobile: [300, 250],
          mobile: true,
          className: 'text-center mb-3 mb-md-4'
        }
      }
    } else if (seoData?.eType === 'cms') {
      return {
        1: {
          id: 'div-ad-gpt-fixed-ads-1',
          adIdDesktop: 'Crictracker_New_Desktop_AP_MID_728x90',
          adIdMobile: 'Crictracker_New_Mobile_AP_MID1_300x250',
          dimensionDesktop: [728, 90],
          slotId: '23148549803',
          dimensionMobile: [300, 250],
          mobile: true,
          hideOn: 'none',
          className: 'text-center mb-3 mb-md-4'
        },
        6: {
          id: 'div-ad-gpt-fixed-ads-6',
          adIdDesktop: 'Crictracker_New_Desktop_AP_BTF_728x90',
          adIdMobile: 'Crictracker_New_Mobile_AP_MID2_300x250',
          slotId: '23148549803',
          dimensionDesktop: [728, 90],
          dimensionMobile: [300, 250],
          mobile: true,
          className: 'text-center mb-3 mb-md-4'
        },
        7: {
          id: 'div-ad-gpt-fixed-ads-7',
          adIdDesktop: 'Crictracker_New_Desktop_AP_MID_728x90',
          adIdMobile: 'Crictracker_New_Mobile_AP_MID1_300x250',
          dimensionDesktop: [728, 90],
          slotId: '23148549803',
          dimensionMobile: [300, 250],
          mobile: true,
          hideOn: 'none',
          className: 'text-center mb-3 mb-md-4'
        }
      }
    } else return {}
  }

  return (
    <Layout data={{ ...cmsData, oSeo: seoData }}>
      <section className="common-section pt-0">
        {data?.seriesScorecard?.length > 0 && <ScorecardSlider data={data?.seriesScorecard} seriesId={cmsData?.oCategory?.iSeriesId} />}
        <div className="container">
          <div className="d-none d-md-block mt-3" style={{ minHeight: '100px' }}>
            {width > 767 && !isStaticPage && (
              // Desktop Top
              <Ads
                id="div-ad-gpt-138639789-1646637094-0"
                adIdDesktop="Crictracker_New_Desktop_AP_ATF1_728x90"
                slotId="23148549803"
                dimensionDesktop={[728, 90]}
                className="text-center"
              />
            )}
          </div>
          <div className="row mt-3">
            <div className="left-content col-xxl-9 col-xl-8">
              <div className={`${styles.CMSContent} common-box mb-0`}>
                {!isMobileWebView && <BreadcrumbNav />}
                <h1>{cmsData?.sTitle}</h1>
                <CommonContent>
                  <ArrayHTML data={cmsData?.aContent} article={cmsData} customAds={getAdCode()} />
                  {/* <div
                    dangerouslySetInnerHTML={{
                      __html: addEditorAds(addAdsInsideParagraph(cmsData?.sContent, seoData?.eType === 'cms' ? [1, 6, 7] : [0, 1, 2, 5]))
                    }}
                  /> */}
                </CommonContent>
                {!isStaticPage && !isMobileWebView && (
                  <OnMouseAndScroll>
                    <Ads
                      id="div-ad-gpt-138639789-1646637259-0"
                      adIdDesktop="Crictracker_New_Desktop_AP_BTF_728x90"
                      adIdMobile="Crictracker_New_Mobile_AP_MID2_300x250"
                      slotId="23148549803"
                      dimensionDesktop={[728, 90]}
                      dimensionMobile={[300, 250]}
                      mobile
                      className={'text-center mt-2'}
                    />
                  </OnMouseAndScroll>
                )}
              </div>
            </div>
            {width > 991 && (
              <div className="common-sidebar d-none d-lg-block col-xxl-3 col-xl-4">
                {/* <SeriesPointTable /> */}
                {cmsData?.oCategory?.iSeriesId && (
                  <>
                    <SeriesMatches id={cmsData?.oCategory?.iSeriesId} seriesStatus={cmsData?.oCategory?.oSeries?.sStatus} />
                    <SeriesPointTable
                      id={cmsData?.oCategory?.iSeriesId}
                      title={cmsData?.oCategory?.oSeries?.sSrtTitle}
                      pageUrl={catSubPagesUrl?.s?.sSlug}
                    />
                  </>
                )}
                <AllWidget type={WIDGET.trendingNews} show />
                {!isStaticPage && (
                  <OnMouseAndScroll>
                    {/* <PixFuture /> */}
                    <Ads
                      id="div-ad-gpt-138639789-1646637134-0"
                      adIdDesktop="Crictracker_New_Desktop_AP_RightMID_300x600"
                      slotId="23148549803"
                      dimensionDesktop={[300, 600]}
                      className="sticky-ads position-sticky mb-2"
                    />
                  </OnMouseAndScroll>
                )}
              </div>
            )}
          </div>
        </div>
      </section>
    </Layout>
  )
}

CMSContent.propTypes = {
  data: PropTypes.object,
  seoData: PropTypes.object
}

export default CMSContent
